import { Routes, Route } from 'react-router-dom';
import { CheckoutPage } from './pages/CheckoutPage';
import { Redirect } from './components/Redirect';

function App() {
  return (
    <Routes>
      {/* Home page - no slug */}
      <Route path="/" element={<Redirect to="https://dio.me" external />} />
      
      {/* Redirect /home to external URL */}
      <Route path="/home" element={<Redirect to="https://dio.me" external />} />
      
      {/* Checkout page with slug parameter */}
      <Route path="/:slug" element={<CheckoutPage />} />
      
      {/* 404 page */}
      <Route path="*" element={<Redirect to="https://dio.me" external />} />
    </Routes>
  );
}

export default App
